import { Component, OnInit, Input, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { ProjectStatus, VersionStatus } from '@usimweb/core/models';

type ProgressBarMode = 'determinate' | 'indeterminate' | 'buffer' | 'query';
@Component({
    selector: 'usimweb-status-bar',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './status-bar.component.html',
    styleUrls: ['./status-bar.component.scss'],
    standalone: false
})
export class StatusBarComponent implements OnInit, OnDestroy {
  @Input() progress: number = 0;

  @Input() top: boolean = true;

  @Input() multiple: boolean = false;

  @Input() projectStatus: ProjectStatus = {} as ProjectStatus;

  @Input() versionStatus: VersionStatus = {} as VersionStatus;

  @Input() mode!: ProgressBarMode;

  constructor() {}

  ngOnInit(): void {
    if (!this.multiple) {
      this.changeFinishedColor();
    }
  }

  ngOnDestroy(): void {
    //document.documentElement.style.setProperty('--finished-color', '#fff');
  }

  public changeFinishedColor(): void {
    document.documentElement.style.setProperty('--finished-color', '#fff');
  }
}
